import React, { useState, useEffect } from "react";
import { Button } from "../Button/Button";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Fade,
} from "@mui/material";
import { storageService, PERSISTENCE_OPTIONS } from "Services/storage_service";
import { CloseIcon } from "../Icons/Miscellaneous/CloseIcon";
import { useTutorial } from "Hooks/useTutorial";
import { Progress } from "Components/Progress/Progress";
import notFound from "Recursos/notFound.png";
import "./Tutorial.scss";

export const Tutorial = () => {
  const tutorial = storageService.getItem("tutorial");
  const showTutorial = tutorial === true;
  const { data, isLoading, fetchData } = useTutorial();
  const [open, setOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [mediaType, setMediaType] = useState("video");
  const totalSteps = data.length - 1;

  const handleClose = () => {
    storageService.setItem("tutorial", false, PERSISTENCE_OPTIONS);
    setOpen(false);
    setCurrentStep(0);
  };

  const handleStart = () => {
    setCurrentStep(1);
  };

  const handleNext = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    } else {
      handleClose();
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  useEffect(() => {
    setMediaType("video");
  }, [currentStep]);

  const handleVideoError = () => {
    setMediaType("image");
  };

  const handleImageError = () => {
    setMediaType("notfound");
  };

  useEffect(() => {
    if (showTutorial) {
      fetchData();
    }
  }, [showTutorial, fetchData]);

  useEffect(() => {
    if (showTutorial && !isLoading && data?.length > 0) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [showTutorial, data, isLoading]);

  useEffect(() => {
    if (tutorial === undefined) {
      storageService.setItem("tutorial", true, PERSISTENCE_OPTIONS);
    }
  }, [tutorial]);

  if (!data?.length) return null;

  const currentContent = data[currentStep];
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === totalSteps;
  const title = currentContent?.titulo || "";
  const description = currentContent?.descripcion || "";
  const progressValue = (currentStep / totalSteps) * 100;
  const hasValidUrl = currentContent?.url?.startsWith("http");

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      onClose={handleClose}
      className="tutorial-dialog"
    >
      <DialogTitle
        className="tutorial-dialog__title"
        dangerouslySetInnerHTML={{ __html: title }}
      />

      <CloseIcon className="tutorial-dialog__close-btn" onClick={handleClose} />

      <DialogContent>
        {currentStep !== 0 && (
          <Progress
            current={progressValue}
            variant="percentage"
            className="tutorial-dialog__progress"
          />
        )}

        <Fade in={true} timeout={300}>
          <div className="tutorial-dialog__media">
            {(!hasValidUrl || mediaType === "notfound") && (
              <img
                src={notFound}
                alt="Contenido no disponible"
                className="tutorial-dialog__image"
              />
            )}

            {hasValidUrl && mediaType === "video" && (
              <video
                src={currentContent.url}
                controls
                className="tutorial-dialog__video"
                preload="metadata"
                muted
                autoPlay
                loop
                onError={handleVideoError}
              />
            )}

            {hasValidUrl && mediaType === "image" && (
              <img
                src={currentContent.url}
                alt="Tutorial"
                className="tutorial-dialog__image"
                onError={handleImageError}
              />
            )}
          </div>
        </Fade>

        <div
          className="tutorial-dialog__description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </DialogContent>

      <DialogActions>
        {isFirstStep ? (
          <Button onClick={handleStart} size="medium">
            INICIAR TUTORIAL
          </Button>
        ) : (
          <>
            <Button
              onClick={handlePrevious}
              size="medium"
              variant="secundario"
              disabled={currentStep === 1}
            >
              REGRESAR
            </Button>
            <Button onClick={handleNext} autoFocus size="medium">
              {isLastStep ? "TERMINAR" : "CONTINUAR"}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};
